'use client';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import ProductsInteractive from './components/ProductsInteractive';
import { Product } from './components/ProductCard';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';
import { t } from '@/lib/translations';

export default function ProductsPage() {
  const { currentLang } = useLanguage();

  const products: Product[] = [
    {
      id: 'product_1',
      name: 'Cvetlični med',
      category: 'Med',
      price: '€14.00',
      description: 'Svetel, sladek med z raznolikih cvetov',
      image: '/images/med/cvetlicni-med.webp',
      alt: 'Kozarec cvetličnega medu Čebelarstvo Pliberšek, 900 g',
    },
    {
      id: 'product_2',
      name: 'Gozdni med',
      category: 'Med',
      price: '€14.00',
      description: 'Temnejši, bogat okus iz gozdnih rastlin',
      image: '/images/med/gozdni-med.webp',
      alt: 'Kozarec gozdnega medu Čebelarstvo Pliberšek, 900 g',
    },
    // {
    //   id: 'product_3',
    //   name: 'Akacijev med',
    //   category: 'Med',
    //   price: '€10.00',
    //   description: 'Kristalno čist, nežen okus',
    //   image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bb6e0d68-1764707183047.png",
    //   alt: 'Clear acacia honey in elegant glass jar with white flowers',
    //   onSale: true
    // },
    {
      id: 'product_4',
      name: 'Kostanjev med',
      category: 'Med',
      price: '€14.00',
      description: 'Močan, rahlo grenak okus',
      image: '/images/med/kostanjev-med.webp',
      alt: 'Kozarec kostanjevega medu Čebelarstvo Pliberšek, 900 g',
    },
    // {
    //   id: 'product_5',
    //   name: 'Lipov med',
    //   category: 'Med',
    //   price: '€6.00',
    //   description: 'Aromatičen, zdravilen med',
    //   image: "https://img.rocket.new/generatedImages/rocket_gen_img_158afebf8-1769981280014.png",
    //   alt: 'Small jar of aromatic linden honey with linden flowers'
    // },
    // {
    //   id: 'product_6',
    //   name: 'Cvetni prah 200g',
    //   category: 'Cvetni prah',
    //   price: '€12.00',
    //   description: 'Bogat vir proteinov in vitaminov',
    //   image: "https://images.unsplash.com/photo-1624858857683-01f5dd02a251",
    //   alt: 'Colorful bee pollen granules in wooden bowl with spoon'
    // },
    // {
    //   id: 'product_7',
    //   name: 'Cvetni prah 500g',
    //   category: 'Cvetni prah',
    //   price: '€25.00',
    //   description: 'Večja embalaža, boljša cena',
    //   image: "https://images.unsplash.com/photo-1570723811540-0f4d1836ef58",
    //   alt: 'Large jar of multicolored bee pollen granules'
    // },
    // {
    //   id: 'product_8',
    //   name: 'Medeni liker',
    //   category: 'Medeni liker',
    //   price: '€15.00',
    //   description: 'Domač liker iz pravega medu',
    //   image: "https://images.unsplash.com/photo-1687957147343-e99dbf4fac7e",
    //   alt: 'Elegant bottle of honey liqueur with amber liquid on dark background'
    // },
    // {
    //   id: 'product_9',
    //   name: 'Medeni liker z orehi',
    //   category: 'Medeni liker',
    //   price: '€18.00',
    //   description: 'Posebna izdaja z orehovim okusom',
    //   image: "https://images.unsplash.com/photo-1673626673787-b80a13339586",
    //   alt: 'Premium honey walnut liqueur bottle with walnuts',
    //   onSale: true
    // },
    // {
    //   id: 'product_10',
    //   name: 'Medenjaki',
    //   category: 'Ostali',
    //   price: '€7.00',
    //   description: 'Tradicionalni slovenski medenjaki',
    //   image: "https://img.rocket.new/generatedImages/rocket_gen_img_18d237d10-1769981279966.png",
    //   alt: 'Traditional Slovenian honey cookies on wooden plate'
    // },
    // {
    //   id: 'product_11',
    //   name: 'Propolisna tinktura',
    //   category: 'Ostali',
    //   price: '€8.00',
    //   description: 'Naravno sredstvo za imunski sistem',
    //   image: "https://images.unsplash.com/photo-1644221362198-4815941c2130",
    //   alt: 'Small amber bottle of propolis tincture with dropper'
    // },
    // {
    //   id: 'product_12',
    //   name: 'Sveča iz čebeljega voska',
    //   category: 'Ostali',
    //   price: '€5.00',
    //   description: '100% naravna sveča',
    //   image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f4a44a74-1765988478888.png",
    //   alt: 'Natural beeswax candle on wooden surface with warm glow'
    // }
  ];

  return (
    <>
      <Header currentLang={currentLang} />
      <main className="pt-40 pb-32 px-6 md:px-10 max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="mb-16 text-center">
          <p className="text-xs font-bold uppercase tracking-[0.4em] text-muted-foreground mb-4">
            {t('products.title', currentLang)}
          </p>
          <h1 className="text-5xl md:text-6xl font-bold tracking-tighter mb-6">
            {t('products.hero', currentLang)}
          </h1>
        </div>

        {/* Products Grid with Filters */}
        <ProductsInteractive products={products} currentLang={currentLang} />

        {/* Quality Assurance Section */}
        <section className="mt-32 text-center">
          <div className="max-w-3xl mx-auto space-y-8">
            <h2 className="text-3xl font-bold tracking-tighter">
              {t('products.quality.title', currentLang)}
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              {t('products.quality.description', currentLang)}
            </p>
            <div className="flex justify-center gap-8 pt-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-success/20 flex items-center justify-center">
                  <Icon name="CheckBadgeIcon" size={24} className="text-success" />
                </div>
                <span className="text-sm font-medium">{t('products.natural', currentLang)}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-success/20 flex items-center justify-center">
                  <Icon name="CheckBadgeIcon" size={24} className="text-success" />
                </div>
                <span className="text-sm font-medium">{t('products.certified', currentLang)}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-success/20 flex items-center justify-center">
                  <Icon name="CheckBadgeIcon" size={24} className="text-success" />
                </div>
                <span className="text-sm font-medium">{t('products.local', currentLang)}</span>
              </div>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="mt-32 text-center">
          <div className="max-w-2xl mx-auto space-y-6">
            <h3 className="text-2xl font-bold">{t('products.visit.title', currentLang)}</h3>
            <p className="text-muted-foreground">{t('products.visit.description', currentLang)}</p>
          </div>
        </section>
      </main>
      <Footer currentLang={currentLang} />
    </>
  );
}
